<template>
  <div ref="templateSearchRootRef" class="template-search-root">
    <el-popover
      ref="searchPopRef"
      placement="bottom-start"
      :width="360"
      trigger="click"
      :showArrow="false"
      popperClass="popover-template-search"
      @show="onSearchPopoverShow"
      @hide="onSearchPopoverHide"
    >
      <template #reference>
        <el-input
          ref="searchRef"
          v-model="searchVal"
          class="search-input"
          placeholder="搜索你所需要的模板"
          maxlength="50"
          @mouseenter="onSearchInputHover"
          @keyup.enter="onSearchClick"
        >
          <template #prefix>
            <IconMyIconInputSearch class="icon-search" @click="onSearchClick"></IconMyIconInputSearch>
          </template>
          <template #suffix>
            <IconMyIconInputClear
              v-show="searchVal"
              class="icon-clear"
              @click="onSearchClearClick"
            ></IconMyIconInputClear>
          </template>
        </el-input>
      </template>
      <template #default>
        <template-search-panel
          v-if="isSearchPanelInit"
          :isSearchPanelShow="isSearchPanelShow"
          @hide-search-panel="onHideSearchPanel"
          @trigger-search="onSearchTrigger"
        ></template-search-panel>
      </template>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
import templateSearchPanel from '@/features/template-type/template-search-panel.vue';
import { onMounted, ref, nextTick } from 'vue';
import { dwOnTemplateTypeSearchClick } from './template-type-dw';
import { getTemplateTypeEmitter } from './template-type.tools';

const searchVal = ref('');

const searchPopRef = ref(null);

const isSearchPanelInit = ref(false);
const onSearchInputHover = () => {
  isSearchPanelInit.value = true;
};

const isSearchPanelShow = ref(false);

const onSearchPopoverHide = () => {
  isSearchPanelShow.value = false;
};

const onSearchPopoverShow = () => {
  isSearchPanelShow.value = true;
};

const onTemplateTypeClick = () => {
  getTemplateTypeEmitter().on('on-template-type-click', () => {
    searchVal.value = '';
  });
};

const bindEvent = () => {
  onTemplateTypeClick();
};

const searchRef = ref();
const triggerSearch = (val: string) => {
  hidePopover();
  getTemplateTypeEmitter().emit('on-app-search-by-key', val || '');

  // 强行把输入框失去焦点
  searchRef.value.blur();

  if (val) {
    dwOnTemplateTypeSearchClick(val);
  }
};

const hidePopover = () => {
  (searchPopRef.value as any)?.hide?.();
};

const onSearchClick = () => {
  triggerSearch(searchVal.value);
};

const onSearchClearClick = () => {
  searchVal.value = '';
};

const onHideSearchPanel = () => {
  hidePopover();
  isSearchPanelShow.value = true;
};

const onSearchTrigger = (val: string) => {
  searchVal.value = val;

  nextTick(() => {
    // 强行把输入框失去焦点, 解决文字被选中问题
    searchRef.value.blur();
  });
};

onMounted(() => {
  bindEvent();
});
</script>

<style lang="scss" scoped>
.template-search {
  &-root {
    flex: 1;
    text-align: right;
    padding-left: 12px;

    .search-input {
      width: 360px;
      &:deep(.el-input__wrapper) {
        height: 30px;
        background-color: var(--lowcode-custom-bg-104);
        border-radius: 15px;
        border-color: transparent;
        box-shadow: none;
        padding: 0 8px 0 10px;

        // &:hover {
        //   border: 1px solid var(--lowcode-ctl-border-02);
        // }

        // &:focus {
        //   border: 1px solid var(--lowcode-theme-common-01);
        // }

        .el-input__prefix,
        .el-input__suffix {
          font-size: 16px;
          &-inner > :last-child {
            margin-right: 0;
          }
        }

        .el-input__inner {
          border-color: transparent;
          padding-left: 3px;
          width: 300px;
          height: 22px;
          font-size: 12px;
          color: var(--lowcode-text-04);
          line-height: 22px;
        }
      }
    }

    .icon-clear {
      :deep(path) {
        fill: #8b95a8;
      }

      &:hover {
        :deep(path) {
          fill: #727e96;
        }
      }

      &:active {
        :deep(path) {
          fill: #444e63;
        }
      }
    }

    .icon-clear,
    .icon-search {
      cursor: pointer;
    }
  }
}

// @media (max-width: 890px) {
//   .template-search {
//     &-root {
//       .search-input {
//         width: 180px;
//         &:deep(.el-input__wrapper) {
//           .el-input__inner {
//             width: 140px;
//           }
//         }
//       }
//     }
//   }
// }
</style>

<style lang="scss">
.el-popper.popover-template-search {
  box-sizing: border-box;
  width: 360px;
  background: var(--lowcode-background-03);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  border: 1px solid var(--lowcode-custom-border-color-01);
  padding: 16px;
  margin-top: -4px !important;

  .hot-search,
  .search-history {
    &-title {
      height: 22px;
      font-size: 12px;
      color: var(--lowcode-text-05);
      line-height: 22px;
      margin-bottom: 10px;
    }

    &-keys {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -8px;
      max-height: 68px;
      overflow: hidden;
    }

    &-key {
      box-sizing: border-box;
      cursor: pointer;
      display: inline-block;
      max-width: 112px;
      background: var(--lowcode-status-02);
      border-radius: 2px;
      padding: 0 8px;
      height: 24px;
      font-size: 12px;
      color: var(--lowcode-text-02);
      line-height: 24px;
      margin-bottom: 12px;
      margin-right: 12px;
      @extend %lowcode-single-line;

      &:hover {
        background: var(--lowcode-custom-bg-27);
      }

      &:active {
        background: var(--lowcode-custom-bg-28);
      }
    }
  }
  .search-history {
    margin-top: 20px;
    position: relative;

    .empty {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      height: 22px;
      font-size: 12px;
      color: var(--lowcode-text-05);
      line-height: 22px;

      &:hover {
        color: var(--lowcode-text-04);
      }

      &:active {
        color: var(--lowcode-text-03);
      }
    }
  }
}

.template-search-root .search-input .el-input__wrapper.is-focus {
  border-color: var(--lowcode-theme-common-01) !important;
}
</style>
